import { getElementClientRect, within } from '../helpers'
import { TModuleState, TPosition } from '../types'

export default function shift({
    placement,
    position,
    reference,
    popup,
    popupConfigs,
    scrollableParents
}: TModuleState) {
    const returnShiftValues: TPosition = {
        x: 0,
        y: 0
    }
    const { isShift = false } = popupConfigs || {}
    /*
     * Return immediately if isShift not enable
     * or postion is fixed
     * */
    if (!isShift || position === 'fixed' || scrollableParents.size === 0) {
        return returnShiftValues
    }
    /*
     * Calculate shifting value
     * */

    const scrollableParent = getElementClientRect(Array.from(scrollableParents)[0])
    const referenceRect = getElementClientRect(reference)
    const popupRect = getElementClientRect(popup)

    /*
     * scrollable container value
     * */
    const scrollableParentLeft = scrollableParent.left
    const scrollableParentRight = scrollableParent.right
    const scrollableParentTop = scrollableParent.top
    const scrollableParentBottom = scrollableParent.bottom

    /*
     * Popup value
     * */
    const popupWidth = popupRect.width
    const popupHeight = popupRect.height

    /*
     * Reference value
     * */
    const referenceLeft = referenceRect.left
    const referenceTop = referenceRect.top
    const referenceWidth = referenceRect.width
    const referenceHeight = referenceRect.height

    switch (placement) {
        case 'top-start':
        case 'bottom-start':
            {
                const popupLeft = referenceLeft
                const popupRight = referenceLeft + popupWidth
                const limitLeft = -referenceWidth
                const limitRight = popupWidth
                const shiftLeft = within({
                    min: limitLeft,
                    value: 0,
                    max: popupLeft - scrollableParentLeft
                })
                const shiftRight = within({
                    min: 0,
                    value: popupRight - scrollableParentRight,
                    max: limitRight
                })
                returnShiftValues.x = shiftLeft + shiftRight
            }
            break
        case 'top':
        case 'bottom':
            {
                const popupLeft = referenceLeft + referenceWidth / 2 - popupWidth / 2
                const popupRight = referenceLeft + referenceWidth / 2 + popupWidth / 2
                const limitLeft = -(referenceWidth / 2 + popupWidth / 2)
                const limitRight = referenceWidth / 2 + popupWidth / 2
                const shiftLeft = within({
                    min: limitLeft,
                    value: 0,
                    max: popupLeft - scrollableParentLeft
                })
                const shiftRight = within({
                    min: 0,
                    value: popupRight - scrollableParentRight,
                    max: limitRight
                })
                returnShiftValues.x = shiftLeft + shiftRight
            }
            break
        case 'top-end':
        case 'bottom-end':
            {
                const popupLeft = referenceLeft + referenceWidth - popupWidth
                const popupRight = referenceLeft + referenceWidth
                const limitLeft = -popupWidth
                const limitRight = referenceWidth
                const shiftLeft = within({
                    min: limitLeft,
                    value: 0,
                    max: popupLeft - scrollableParentLeft
                })
                const shiftRight = within({
                    min: 0,
                    value: popupRight - scrollableParentRight,
                    max: limitRight
                })
                returnShiftValues.x = shiftLeft + shiftRight
            }
            break
        case 'left-start':
        case 'right-start':
            {
                const popupTop = referenceTop
                const popupBottom = referenceTop + popupHeight
                const limitTop = -referenceHeight
                const limitBottom = popupHeight
                const shiftTop = within({
                    min: limitTop,
                    value: 0,
                    max: popupTop - scrollableParentTop
                })
                const shiftBottom = within({
                    min: 0,
                    value: popupBottom - scrollableParentBottom,
                    max: limitBottom
                })
                returnShiftValues.y = shiftTop + shiftBottom
            }
            break
        case 'left':
        case 'right':
            {
                const popupTop = referenceTop + referenceHeight / 2 - popupHeight / 2
                const popupBottom = referenceTop + referenceHeight / 2 + popupHeight / 2
                const limitTop = -(referenceHeight / 2 + popupHeight / 2)
                const limitBottom = referenceHeight / 2 + popupHeight / 2
                const shiftTop = within({
                    min: limitTop,
                    value: 0,
                    max: popupTop - scrollableParentTop
                })

                const shiftBottom = within({
                    min: 0,
                    value: popupBottom - scrollableParentBottom,
                    max: limitBottom
                })
                returnShiftValues.y = shiftTop + shiftBottom
            }
            break
        case 'left-end':
        case 'right-end':
            {
                const popupTop = referenceTop + referenceHeight - popupHeight
                const popupBottom = referenceTop + referenceHeight
                const limitTop = -popupHeight
                const limitBottom = referenceHeight
                const shiftTop = within({
                    min: limitTop,
                    value: 0,
                    max: popupTop - scrollableParentTop
                })
                const shiftBottom = within({
                    min: 0,
                    value: popupBottom - scrollableParentBottom,
                    max: limitBottom
                })
                returnShiftValues.y = shiftTop + shiftBottom
            }
            break
    }
    return returnShiftValues
}
